/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TableModule} from '../../shared/table/table.module';
import {PeriodBundlesTableComponent} from './period-bundles-table.component';
import {CardModule} from '../../shared/card/card.module';
import {BundleInformationTableModule} from '../bundle-information-table/bundle-information-table.module';
import {ProgressBarLineModule} from '../../shared/progress-bar/progress-bar-line/progress-bar-line.module';
import {ProgressBarSquareModule} from '../../shared/progress-bar/progress-bar-square/progress-bar-square.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {InfoChartModule} from '../../shared/info-chart/info-chart.module';
import {PaginationModule} from '../../shared/pagination/pagination.module';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {BundlesPipesModule} from '../shared/pipes/bundles-pipes.module';
import {CopyPasteModule} from '../../shared/copy-paste/copy-paste.module';

@NgModule({
    declarations: [PeriodBundlesTableComponent],
    imports: [
        CommonModule,
        TableModule,
        CardModule,
        BundleInformationTableModule,
        ProgressBarLineModule,
        ProgressBarSquareModule,
        PipesModule,
        InfoChartModule,
        PaginationModule,
        TooltipModule,
        BundlesPipesModule,
        CopyPasteModule
    ],
    exports: [PeriodBundlesTableComponent]
})
export class PeriodBundlesTableModule {
}
